import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import classnames from 'classnames';
import { useUID } from 'dibs-uid';
import { getSrcsetString } from '../../../utils/srcSet';
import { SRC_SET_SIZES_RESP_RECENTLY_VIEWED_TILE } from '../../../constants/imageConstants';
import { Link } from 'dibs-elements/exports/Link';

// styles
import styles from './PdpRespSimilarItemCarousel.scss';

export function PdpRespSimilarItemCarouselComponent({ index, item, isCondensed, onClick }) {
    const uid = useUID() || undefined;
    const { title, pdpURL, isArt, creators, photos } = item || {};
    const creatorName = creators?.[0]?.creator?.name;
    const itemPhoto = photos?.[0] || {};
    const imgSrc = itemPhoto.versions?.[0]?.webPath || '';
    const masterPath = itemPhoto.masterOrZoomPath;

    const srcSetAttributes = masterPath
        ? {
              srcSet: getSrcsetString(masterPath),
              sizes: SRC_SET_SIZES_RESP_RECENTLY_VIEWED_TILE,
          }
        : {};

    const containerClass = classnames(styles.itemContainer, {
        [styles.isCondensed]: !!isCondensed,
    });

    return (
        <div className={containerClass}>
            <Link
                href={pdpURL}
                onClick={event => onClick(index, event)}
                id={uid}
                underline="none"
                className={styles.overlayLink}
            >
                {isArt && creatorName && `${creatorName} - `}
                {title}
            </Link>
            {imgSrc && (
                <div className={styles.imageWrapper}>
                    <img
                        className={styles.image}
                        aria-labelledby={uid}
                        src={imgSrc}
                        alt={title}
                        {...srcSetAttributes}
                    />
                </div>
            )}
        </div>
    );
}

PdpRespSimilarItemCarouselComponent.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    isCondensed: PropTypes.bool,
    onClick: PropTypes.func,
};

export const PdpRespSimilarItemCarousel = createFragmentContainer(
    PdpRespSimilarItemCarouselComponent,
    {
        item: graphql`
            fragment PdpRespSimilarItemCarousel_item on Item {
                title
                pdpURL
                isArt
                creators {
                    creator {
                        name
                    }
                }
                photos(limit: 1) {
                    masterOrZoomPath
                    versions {
                        webPath
                    }
                }
                ...LazyImageWrapper_item
            }
        `,
    }
);
